// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/permission/permission.css
// module id = 2013
// module chunks = 0